import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  container: {
    padding: '40px 32px',
    width: '100%',
    fontSize: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontFamily: 'Helvetica',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    fontWeight: 400,
  },
  title: {
    marginBottom: 16,
    fontSize: 20,
    fontWeight: 700,
    fontFamily: 'Helvetica-Bold',
  },
  logoContainer: {
    width: '2cm',
    height: '2cm',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
    overflow: 'hidden',
  },
  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  tableHeaders: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 8,
  },
  line: {
    height: 0.75,
    width: '100%',
    backgroundColor: '#1f1e1e',
    margin: '6 0',
  },
  shopDetails: {
    marginTop: 4,
  },
  rowLine: {
    marginBottom: 6,
  },
  totalLine: {
    borderTop: '0.24px solid #c5c4c4',
    borderBottom: '0.24px solid #c5c4c4',
    padding: '6 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  color: { color: '#d1a245' },
  bold: { fontWeight: 'bold', fontFamily: 'Helvetica-Bold' },
  flex: { display: 'flex', flexDirection: 'row' },
  link: { textDecoration: 'none', color: '#d1a245' },
})

export const htmlPdfStyles = {
  b: {
    fontFamily: 'Helvetica-Bold',
    fontWeight: 'bold',
  },
  p: {
    margin: 0,
    padding: 0,
    fontSize: 8,
    fontFamily: 'Helvetica',
  },
}
